import React from 'react';
import { useAppSelector } from 'renderer/shared/state/hooks';
import { selectUser } from 'renderer/features/auth/state/userSelectors';
import EditUser from './EditUser';

const GeneralTab: React.FC = () => {
  const user = useAppSelector(selectUser);
  if (user.role === 'public') return null;

  const { _id: userId } = user;
  return <EditUser userId={userId} />;
};

export default GeneralTab;
